import React from 'react';
import defaultImg from 'img/hero_image.png';

const ChallengeImage = (props) => {
  const  { src, classes } = props || {}
    return(
      <img
        className={classes?.challenge_img}
        src={src}
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = defaultImg;
        }}
        alt="challenge"
      />
    );
  }

export default ChallengeImage;
